// SubDocumentType
export const addSubDocumentType = ({ form }) => {
    form.setConfig({
        "title": "Add Sub Document Types",
        "type": "push",
        "location": "Database/SubDocumentTypes",
        "fields": [{
            "label": "Name",
            "name": "Name",
            "type": "text"
        }]
    });
    form.toggle();
}

export const editSubDocumentType = ({ form, rowItem }) => {
    form.setValues({
        "Name": rowItem.Name
    });
    form.setConfig({
        "title": "Edit Sub Document Types",
        "type": "update",
        "location": `Database/SubDocumentTypes/${rowItem.ID}`,
        "fields": [{
            "label": "Name",
            "name": "Name",
            "type": "text"
        }]
    });
    form.toggle();
}
